var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2511 6.59333C18.9395 6.78225 19.4817 7.33889 19.6657 8.04577C20.0001 9.32691 20.0001 12 20.0001 12C20.0001 12 20.0001 14.673 19.6657 15.9543C19.4817 16.6612 18.9395 17.2178 18.2511 17.4068C17.0034 17.75 12 17.75 12 17.75C12 17.75 6.99665 17.75 5.74892 17.4068C5.06046 17.2178 4.51828 16.6612 4.33427 15.9543C4 14.673 4 12 4 12C4 12 4 9.32691 4.33427 8.04577C4.51828 7.33889 5.06046 6.78225 5.74892 6.59333C6.99665 6.25 12 6.25 12 6.25C12 6.25 17.0034 6.25 18.2511 6.59333ZM10.4997 9.75V14.75L14.4997 12.2501L10.4997 9.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fd3939e2feb4ce9e0cd52373bef59d50.svg";
export { ForwardRef as ReactComponent };